const SafeLauncherUrlSchemes: Array<string> = ['https:', 'http:', 'mailto:', 'tel:', 'sms:', 'webcal:'];
const UrlSchemePattern = /^[a-z][a-z0-9+.-]*:/i;

/**
 * Returns true when the URL has a scheme that is safe to navigate to.
 * Empty, relative, and scheme-less strings are considered safe to preserve existing launcher behavior.
 * Rejects javascript:, data:, vbscript:, and any other executable scheme.
 */
export function isSafeLauncherUrl(url: string): boolean {
  if (url === '') {
    return true;
  }

  const schemeMatch = url.trim().match(UrlSchemePattern);
  if (schemeMatch === null) {
    return true;
  }

  return SafeLauncherUrlSchemes.includes(schemeMatch[0].toLowerCase());
}
